import React from "react";

export default function VerifiedIcon() {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.6667 1.53228L9.16669 0.0322767C9.05886 0.0107255 8.94784 0.0107255 8.84002 0.0322767L1.34002 1.53228C1.15042 1.56937 0.979606 1.67118 0.856783 1.8203C0.73396 1.96942 0.666763 2.15659 0.666687 2.34978V10.8331C0.666687 17.4998 9.00002 19.9998 9.00002 19.9998C9.00002 19.9998 17.3334 17.4998 17.3334 10.8331V2.34978C17.3336 2.15752 17.2673 1.97111 17.1458 1.82212C17.0243 1.67312 16.8551 1.57073 16.6667 1.53228ZM8.21419 13.7256L4.48835 9.99978L5.66669 8.82144L8.11919 11.2739L13.0767 5.49144L14.3417 6.57478L8.21419 13.7256Z"
				fill="#17AD92"
			/>
		</svg>
	);
}
